import React, { useState } from 'react';
import { formatNumber } from './utils';
import ModalWrapper from './ModalWrapper';

function BookingModal({ open, item, onClose, onSuccess }) {
  const [qty, setQty] = useState('');
  const [orderNumber, setOrderNumber] = useState('');
  const [note, setNote] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // Reset fields when modal opens or item changes
  React.useEffect(() => {
    if (open) {
      setQty('');
      setOrderNumber('');
      setNote('');
      setError('');
    }
  }, [open, item]);

  if (!open || !item) return null;

  const availableQty = item.currentQty - (item.bookedQty || 0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    if (!qty || isNaN(qty) || Number(qty) <= 0) {
      setError('Quantity must be a positive number');
      setSubmitting(false);
      return;
    }
    // Check if this would create a backorder
    if (Number(qty) > availableQty) {
      // Only allow backorders for Stock Management items (minQty > 0)
      if (item.minQty <= 0) {
        setError('Not enough available stock to book. Backorders not allowed for Over Runs items.');
        setSubmitting(false);
        return;
      }
      // For Stock Management items, allow backorders but show warning
      const backorderQty = Number(qty) - availableQty;
    }
    if (!orderNumber) {
      setError('Work Ticket Nr is required');
      setSubmitting(false);
      return;
    }
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL || ''}/bookings`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          stockItemId: item.id,
          orderNumber,
          qty: Number(qty),
          note
        })
      });
      if (!res.ok) {
        const err = await res.json();
        console.error('[BOOKING ERROR RESPONSE]', err);
        throw new Error(err.error || 'Failed to create booking');
      }
      const booking = await res.json();
      onSuccess && onSuccess(booking);
      onClose();
    } catch (err) {
      console.error('[BOOKING ERROR CAUGHT]', err);
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ModalWrapper open={open} onClose={onClose} zIndex={50}>
      <h2 style={{color:'#1976d2',fontWeight:800,marginBottom:10,fontSize:22,letterSpacing:1}}>Book Stock for Dispatch</h2>
      <form onSubmit={handleSubmit} style={{width:'100%',display:'flex',flexDirection:'column',gap:18}}>
        <div style={{background:'#f8fafc',padding:16,borderRadius:12,width:'100%',marginBottom:8}}>
          <div><b>Customer:</b> {item.client ? item.client.name : ''}</div>
          <div><b>Product Code:</b> {item.productCode}</div>
          <div><b>Description:</b> {item.mainCategory}</div>
          <div><b>Variant:</b> {item.variantDesc}</div>
          <div><b>Label Size:</b> {item.labelSize || '-'}</div>
          <div><b>Current Qty:</b> {formatNumber(item.currentQty)}</div>
          <div><b>Min Qty:</b> {formatNumber(item.minQty)}</div>
          <div><b>Cost (R/1000):</b> {item.cost ? `R${formatNumber(item.cost)}` : '-'}</div>
          <div><b>Total Value:</b> {item.cost ? `R${formatNumber((item.currentQty * item.cost) / 1000)}` : '-'}</div>
        </div>
        <div style={{display:'flex', flexDirection:'column', gap:10}}>
          <label style={{fontWeight:500,marginBottom:2}}>Work Ticket Nr <span style={{color:'red'}}>*</span></label>
          <input 
            type="number" 
            value={orderNumber} 
            onChange={e => setOrderNumber(e.target.value)} 
            placeholder="e.g., 3456 (WT will be added automatically)"
            required 
            style={{padding:10, borderRadius:6, border:'1px solid #bdbdbd'}} 
          />
        </div>
        <div style={{display:'flex', flexDirection:'column', gap:10}}>
          <label style={{fontWeight:500,marginBottom:2}}>Quantity <span style={{color:'red'}}>*</span></label>
          <input type="number" value={qty} onChange={e => setQty(e.target.value)} min="1" required style={{padding:10, borderRadius:6, border:'1px solid #bdbdbd'}} />
        </div>
        <div style={{display:'flex', flexDirection:'column', gap:10}}>
          <label style={{fontWeight:500,marginBottom:2}}>Available: {formatNumber(availableQty)}</label>
          <textarea value={note} onChange={e => setNote(e.target.value)} style={{padding:10, borderRadius:6, border:'1px solid #bdbdbd',minHeight:50, fontFamily:'inherit'}} />
        </div>
        {error && <div style={{color:'red',marginBottom:8}}>{error}</div>}
        <div style={{display:'flex',gap:16,justifyContent:'center',marginTop:12}}>
          <button type="submit" disabled={submitting} style={{background:'#1976d2',color:'#fff',fontWeight:700,padding:'10px 32px',border:'none',borderRadius:8,boxShadow:'0 2px 8px #1976d233',fontSize:16}}>{submitting ? 'Booking...' : 'Book'}</button>
          <button type="button" onClick={onClose} style={{background:'#fff',color:'#1976d2',fontWeight:700,padding:'10px 32px',border:'1.5px solid #1976d2',borderRadius:8,fontSize:16}}>Cancel</button>
        </div>
      </form>
    </ModalWrapper>
  );
}

export default BookingModal;
